import Marquee from "react-fast-marquee";
import { useLang } from "@/context/LanguageContext";

export const ValuesMarquee = () => {
  const { t } = useLang();
  return (
    <div className="py-8 border-y border-white/10 bg-[#111827]" data-testid="values-marquee">
      <Marquee speed={38} gradient={false} autoFill>
        {t.marquee.map((word, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-extrabold uppercase text-3xl sm:text-5xl px-8 outline-text">
              {word}
            </span>
            <span className="text-[#E85D04] text-2xl sm:text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
